<template>
  <div class="tech btn"></div>
</template>
<script>
export default {
  name: "tech",
  methods: {
    btnTechHandler: function() {
      window.location.href = "https://www.foshannews.net/";
    }
  }
};
</script>
<style lang="scss" scoped>
.tech {
  position: absolute;
  @include w(238);
  @include h(24);
  @include bg("tech.png");
  @include center(238);
  z-index: 8;
  bottom: 0.5rem;
}
</style>
